var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        switchFullscreen: "",
        cancelText: "关闭",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "name",
                    label: "分类名称",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入分类名称" },
                    model: {
                      value: _vm.model.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "name", $$v)
                      },
                      expression: "model.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "level",
                    label: "1-一级分类 2-二级分类",
                  },
                },
                [
                  _c("a-input-number", {
                    attrs: { placeholder: "请输入1-一级分类 2-二级分类" },
                    model: {
                      value: _vm.model.level,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "level", $$v)
                      },
                      expression: "model.level",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "sort",
                    label: "排序值（越小越靠前）",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "sort", $$v)
                      },
                      expression: "model.sort",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }